import { render, staticRenderFns } from "./OnlineCourseListContentUnit.vue?vue&type=template&id=2c2827b0&scoped=true&"
import script from "./OnlineCourseListContentUnit.vue?vue&type=script&lang=js&"
export * from "./OnlineCourseListContentUnit.vue?vue&type=script&lang=js&"
import style0 from "./OnlineCourseListContentUnit.vue?vue&type=style&index=0&id=2c2827b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2827b0",
  null
  
)

export default component.exports